import { motion } from "framer-motion";
import { Footprints, Wind, Activity, Flag } from "lucide-react";

const chapters = [
  {
    num: "01",
    icon: Footprints,
    title: "The Dual-Foot Flaw",
    body: "Two-foot stools hoist both legs and lock your hips into a rigid squat. Symmetry feels safe — but your sphincter reads it as a full-body clench.",
  },
  {
    num: "02",
    icon: Wind,
    title: "The One-Foot Unclog",
    body: "Master Blaster elevates a single foot. One side grounded, one side lifted — your pelvic floor gets the signal to let go instead of hold on.",
  },
  {
    num: "03",
    icon: Activity,
    title: "Pelvic Asymmetry Release",
    body: "The offset angle gently twists the hips, relaxing the sphincter muscles and straightening the path. Less pushing. More flowing. Science-adjacent, results-forward.",
  },
  {
    num: "04",
    icon: Flag,
    title: "Americana Built Tough",
    body: "Red, white and blue, through and through. Built for American toilets, American bathrooms, and Americans who refuse to strain on the throne of freedom.",
  },
];

export const Manifesto = () => (
  <section id="science" data-testid="manifesto-section" className="relative py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-16"
      >
        <p className="font-jbmono text-xs uppercase tracking-[0.25em] text-crimson mb-4">The Manifesto</p>
        <h2 className="font-display font-black uppercase text-3xl sm:text-5xl leading-none tracking-tight max-w-3xl">
          Why one foot beats two. <span className="text-stroke-cream">Every single time.</span>
        </h2>
      </motion.div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {chapters.map((c, i) => (
          <motion.article
            key={c.num}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.12 }}
            data-testid={`manifesto-chapter-${c.num}`}
            className="group relative bg-midnight border border-steel/60 rounded-lg p-8 hover:border-crimson/70 transition-colors duration-300"
          >
            <span className="font-display font-black text-6xl text-stroke-cream absolute top-6 right-6 select-none">
              {c.num}
            </span>
            <c.icon className="w-8 h-8 text-gold mb-6 group-hover:text-crimson transition-colors duration-300" />
            <h3 className="font-display font-bold uppercase text-xl sm:text-2xl tracking-tight mb-3">{c.title}</h3>
            <p className="text-sm leading-relaxed text-cream/60">{c.body}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
